import DataLayer from '@services/data-layer/index'
import localSave from '@utils/local-save'

const TYPES = ['mixes', 'artists', 'shows', 'genres']
const LIST_MUTATION = {
    mixes: 'UPDATE_FAVORITE_MIXES',
    artists: 'UPDATE_FAVORITE_ARTISTS',
    shows: 'UPDATE_FAVORITE_SHOWS',
    genres: 'UPDATE_FAVORITE_GENRES',
}
const LIST_KEY = {
    mixes: 'mixesList',
    artists: 'artistsList',
    shows: 'showsList',
    genres: 'genresList',
}

function currentMemberId(rootState) {
    return rootState.auth.currentUser?.members_id?.id
}

export const state = {
    mixesList: [],
    artistsList: [],
    showsList: [],
    genresList: [],
    channelIds: localSave.get('favoriteChannels') || localSave.get('favorites') || [],
    loaded: {},
}

export const getters = {
    genreIds: state => state.genresList.map(item => item.id),
    likedMixes: state => state.mixesList.map(record => record.mixes).filter(Boolean),
    followedArtists: state => state.artistsList.map(record => record.artists).filter(Boolean),
    followedShows: state => state.showsList.map(record => record.shows).filter(Boolean),
    followedGenres: state => state.genresList.map(record => record.genres).filter(Boolean),
    isLoaded: state => type => Boolean(state.loaded[type]),
}

export const mutations = {
    UPDATE_FAVORITE_MIXES(state, data) {
        if (!data) return
        state.mixesList = data
    },
    UPDATE_FAVORITE_ARTISTS(state, data) {
        if (!data) return
        state.artistsList = data
    },
    UPDATE_FAVORITE_SHOWS(state, data) {
        if (!data) return
        state.showsList = data
    },
    UPDATE_FAVORITE_GENRES(state, data) {
        if (!data) return
        state.genresList = data
    },
    SET_FAVORITE_CHANNELS(state, ids) {
        state.channelIds = ids
        localSave.save('favoriteChannels', ids)
    },
    SET_TYPE_LOADED(state, type) {
        state.loaded = { ...state.loaded, [type]: true }
    },
}

export const actions = {
    // Load all favorite lists for the current user (on login / route change).
    init({ dispatch }) {
        return Promise.all(TYPES.map(type => dispatch('fetchType', type)))
    },

    async fetchType({ commit, rootState }, type) {
        const membersId = currentMemberId(rootState)
        if (!membersId) return
        // `list` already flattens each record down to a top-level `id`.
        const { body } = await DataLayer.favorites.list({ type, membersId, limit: 100000 })
        commit(LIST_MUTATION[type], body || [])
        commit('SET_TYPE_LOADED', type)
    },

    async fetchPage({ rootState }, { type, offset = 0, limit = 30 }) {
        const membersId = currentMemberId(rootState)
        if (!membersId) return []
        const { body } = await DataLayer.favorites.list({ type, membersId, offset, limit })
        return body || []
    },

    async add({ dispatch, rootState }, { type, id }) {
        const membersId = currentMemberId(rootState)
        await DataLayer.favorites.add({ type, membersId, id })
        await dispatch('fetchType', type)
    },

    async remove({ commit, state, rootState }, { type, id }) {
        const membersId = currentMemberId(rootState)
        await DataLayer.favorites.remove({ type, membersId, id })
        commit(LIST_MUTATION[type], state[LIST_KEY[type]].filter(item => item.id !== id))
    },

    toggleChannel({ commit, state }, channelId) {
        const channelIds = state.channelIds.includes(channelId)
            ? state.channelIds.filter(id => id !== channelId)
            : [...state.channelIds, channelId]
        commit('SET_FAVORITE_CHANNELS', channelIds)
    },
}
